import React, { useEffect, useState } from "react";
import { useOrganisationContext } from "hooks";
import { Trans, useTranslation } from "react-i18next";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ApiClient } from "services";
import { NotificationManager } from "react-notifications";
import LoadingMsg from "components/common/LoadingMsg";
import Select from "react-select";
import { FormGroup } from "components/common/Forms/FormGroup";

export const AccessPermissions = ({ show, handleClose, details, org, userID}) => {

  const {t} = useTranslation()
  const { organisations } = useOrganisationContext();
  const client = ApiClient()
  const [accessData, setAccess] = useState();
  const [loading, setLoading] = useState(false);
  const [confirmRemove, setConfirmDelete] = useState(false);
  const [confirmAdd, setConfirmAdd] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [deleteName, setDeleteName] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const [selectedLabel, setSelectedLabel] = useState();

  const checkOrgs = org ? org : organisations

const handleSelect = (data) => {
    const { value, label } = data || {}
    setSelectedValue(value)
    setSelectedLabel(label)
};

const handleDeleteClick = (id, name) => {
    setConfirmAdd(false);
    setDeleteId(id);
    setDeleteName(name);
    setConfirmDelete(true);
};

const handleAddClick = () => {
    setConfirmAdd(true);
    setConfirmDelete(false);
};

const handleAddClose = () => {
    setConfirmAdd(false);
};

const handleCancelDelete = () => {
    setConfirmDelete(false);
};

  const refresh = async () => {
    try {
        if (!userID) return
        
        const responseLoans = await client.get(`authorization/enrollment_user_id/get/${userID}`);
        const loansData = responseLoans.data;
        setAccess(loansData);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

useEffect(() => {
    refresh(); 
}, [userID]);


const confirmDelete = () => {
    setLoading(true)
    client.delete(`/authorization/company_user_assign_organisation/${deleteId}`)
    .then(({ response }) => {
        console.log(response, "server")
        refresh();
        NotificationManager.success(t(`User Access Revoked from ${deleteName}`))
        setLoading(false)
        setDeleteName()
        setDeleteId()
    })
    .catch(error => {
        console.error(error); 
        NotificationManager.error('Failed to revoke user access')
        setLoading(false)
    });
    setConfirmDelete(false);
};

const getOrgName = (id) => {
    const orgz = checkOrgs?.find(org => org.id === id);
    return orgz ? orgz.name : id;
};

const confirmAddAccess = () => {
    setLoading(true)
    const data = {
        user: userID,
        ref_connected_organisation: selectedValue 
    };
    client.post('/authorization/company_user_assign_organisation', data)
    .then(({ response }) => {
        console.log(response, "server")
        refresh();
        NotificationManager.success(t(`User Access Added to ${getOrgName(selectedValue)}`))
        setLoading(false)
        setSelectedLabel()
        setSelectedValue()
    })
    .catch(error => {
        console.error(error); 
        NotificationManager.error('Failed to revoke user access')
        setLoading(false)
    });
    setConfirmAdd(false);
};

const options = checkOrgs?.filter(org => !accessData?.some(data => data.ref_connected_organisation === org.id))?.map(org => ({
    value: org.id,
    label: org.name
}));

const optionsAvailable = options.length > 0
  
  return (
    <Modal isOpen={show} toggle={handleClose}>
        <ModalHeader closeButton>Change User Access</ModalHeader>
        <ModalBody style={{overflowY: 'visible'}}>
        {loading ? <LoadingMsg/>:
            <>
            {accessData?.length > 0 ? 
            <table className="table table-sm border">
                <thead>
                <tr>
                    <th className="text-left"><Trans>Organisations Connected</Trans></th>
                    <th className="text-right"><Trans>Remove</Trans></th>
                </tr>
                </thead>
                <tbody>
                {accessData.map((i) => {
                    const orgName = checkOrgs.find(org => org.id === i.ref_connected_organisation)?.name || `User Organisation ${i.ref_connected_organisation}`;
                    return (
                        <tr key={i.id}>
                            <td className="text-left">{orgName || i.ref_connected_organisation}</td>  
                            <td className="text-right">
                                <button className='btn btn-danger btn-sm' onClick={() => handleDeleteClick(i.id, orgName)}>
                                    <span className="fa fa-times" style={{ fontSize: 15, marginTop: "0.15em" }}></span>
                                </button>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
                :<div className="mb-2 alert alert-warning text-center"><Trans>{details?.first_name} does not have access to any organisation</Trans></div>
            }
            {confirmRemove && (
                <div className="mb-4 alert alert-secondary">
                    <p><Trans>Are you sure you want to remove {deleteName} access from {details.first_name} {details.last_name} ?</Trans></p>
                    <Button color="danger" className="btn-sm mx-0" onClick={confirmDelete}><Trans>Yes</Trans></Button>
                    <Button color="primary" className="btn-sm" onClick={handleCancelDelete}><Trans>No</Trans></Button>
                </div>
            )}
            {!confirmAdd && <Button color="primary" className="my-2 mx-0 w-100" onClick={handleAddClick}><span className="fa fa-plus mr-1"/><Trans>Add New Access</Trans></Button>}
            {confirmAdd && (
                <div className="mb-4 alert alert-secondary">
                    {optionsAvailable ? <FormGroup label="Select an Organisation"><Select clearable={false} value={selectedValue} onChange={handleSelect} options={options}/></FormGroup>: <span><Trans>No More Organisations Found</Trans></span> }
                    {selectedValue ? <><p className="mt-3"><Trans>Are you sure you want to add {selectedLabel || selectedValue} access to {details.first_name} {details.last_name} ?</Trans></p>
                    <Button color="primary" className="btn-sm mx-0" onClick={confirmAddAccess}><Trans>Yes</Trans></Button>
                    <Button color="danger" className="btn-sm" onClick={handleAddClose}><Trans>No</Trans></Button></>:<>{optionsAvailable && <div className="mt-3"><Trans>Please choose an organization to grant access to the user.</Trans></div>}</>}
                </div>
            )}
            </>
        }
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={handleClose}><Trans>Close</Trans></Button>
        </ModalFooter>
    </Modal>
  );
};

export default AccessPermissions;
